import React, { useState, useEffect, useRef, useCallback } from "react";
import OtpInput from "react-otp-input";
import OtpPageWrapper from "./OtpPageStyle";
import { withTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { config } from "../../config";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { MuiOtpInput } from "mui-one-time-password-input";
import { setLoading } from "../../redux/actions/travel";
import CountdownTimer from "./CountdownTimer";
import * as travelService from "../../services/travel-service";
import * as renewalService from "../../services/renewal-service";
import * as globalUtils from "../../helpers/utils";

const OtpPage = (props) => {
  const { lob = "All", userDetails } = props;
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const toast = useRef(null);
  // const [display, setDisplay] = useState(show);
  const [resetCounter, updateResetCounter] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [loader, setLoader] = useState(false);
  const { businessLine } = useSelector((state) => state.travel);

  useEffect(() => {
    if (props.show) {
      sendOTP();
    }
  }, [props.show]);

  function matchIsNumeric(text) {
    const isNumber = typeof text === "number";
    const isString = typeof text === "string";
    return (isNumber || isString) && !isNaN(Number(text));
  }

  const validateChar = (value) => {
    return matchIsNumeric(value);
  };

  const sendOTP = () => {
    dispatch(setLoading(true));
    if (lob === "Renewal" || lob === "NormalRenewal") {
      renewalService
        .verifyClient({
          idNumber: userDetails.idNo,
          yob: userDetails.yob,
          language: globalUtils.getTwoLetterLanguageCode(props.i18n.language),
        })
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.verifyClientResponse.resultCode == "S") {
            // toast.current.show({
            //   severity: "success",
            //   detail: props.t("otp-send-successfully"),
            //   life: 10000,
            // });
          } else {
            toast.current.show({
              severity: "error",
              detail: response.data.verifyClientResponse.resultMessage,
              life: 10000,
            });
          }
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            detail: "System Error",
            life: 10000,
          });
          dispatch(setLoading(false));
        });
    } else {
      travelService
        .sendOTP({
          mobile: globalUtils.prepareMobileNumber(props.mobileNumber),
          channel: "Portal",
          businessService: "MOTOR",
          language: globalUtils.getNumberRepresentedLanguageCode(
            props.i18n.language
          ),
        })
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.status == "1") {
            toast.current.show({
              severity: "success",
              detail: props.t("otp-send-successfully"),
              life: 10000,
            });
          } else {
            toast.current.show({
              severity: "error",
              detail: response.data.resultMessage,
              life: 10000,
            });
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    }
  };

  const verifyOTP = () => {
    if (lob === "Renewal" || lob === "NormalRenewal") {
      props.handleOnVerifyOTPClicked(otp);
      return;
    }

    setLoader(true);
    dispatch(setLoading(true));

    travelService
      .verifyOTP({
        mobile: globalUtils.prepareMobileNumber(props.mobileNumber),
        otpCode: otp,
        channel: "MOTOR",
        language: globalUtils.getNumberRepresentedLanguageCode(
          props.i18n.language
        ),
      })
      .then((response) => {
        dispatch(setLoading(false));
        setLoader(false);
        if (response.data.status == "1") {
          props.onSuccessVerify(true);
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.statusDescritpion,
            life: 10000,
          });
        }
      });
  };

  const resendOTP = () => {
    updateResetCounter(true);
    setCanResend(false);
    sendOTP();
    setTimeout(() => {
      updateResetCounter(false);
    }, 1000);
  };

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;

  return (
    <Dialog
      visible={props.show}
      showHeader={false}
      closable={true}
      modal={true}
      onHide={props.cancelOTP}
      contentStyle={{ padding: "20px", borderRadius: "10px" }}
    >
      <Toast ref={toast} />
      <OtpPageWrapper>
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <div className="col-12 col-sm-12">
              <div className="d-flex justify-content-center">
                <h2
                  className={
                    businessLine
                      ? `otpVerificationTitle-${businessLine} otpVerificationTitle`
                      : "otpVerificationTitle"
                  }
                >
                  {props.t("otp-verification-title")}
                </h2>
              </div>
              <div className="d-flex justify-content-center">
                <p className="otpSentMessageStyle">
                  {props.t("otp-sent-mobile")}
                  <br />
                  {/* {props.t("ending-with")} */}
                  {props.mobileNumber && (
                    <span className="lato">
                      *
                      {props.mobileNumber.substring(
                        props.mobileNumber.length - 4,
                        props.mobileNumber.length
                      )}
                    </span>
                  )}
                </p>
              </div>
              <h4 className="countdownTextStyle">
                {props.t("remaining-time")}:
                <span className="countdownStyle">
                  <CountdownTimer
                    onFinish={() => setCanResend(true)}
                    resetCounter={resetCounter}
                    count={config.otpPeriod}
                  />
                </span>
              </h4>
              <div dir="ltr" className="d-flex justify-content-center">
                <MuiOtpInput
                  autoFocus
                  gap={4}
                  validateChar={validateChar}
                  onChange={(e) => setOtp(e)}
                  value={otp}
                  // {...rest}
                  TextFieldsProps={{
                    type: "number",
                    inputProps: {
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                  }}
                  style={{ maxWidth: 300 }}
                  inputProps={{
                    autoComplete: "one-time-code",
                  }}
                  sx={(theme) => ({
                    flexDirection:
                      theme.direction === "rtl" ? "row-reverse" : "row",
                  })}
                />

                {/* <OtpInput
                  inputType="number"
                  isInputNum={true}
                  value={otp}
                  onChange={(e) => setOtp(e)}
                  placeholder="0000"
                  focusStyle={{
                    border: "1px solid #EAEAEA",
                    outline: "none",
                    width: "60px",
                    height: "60px",
                  }}
                  separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                  numInputs={4}
                  inputStyle="containerStyle lato"
                /> */}
              </div>
              <h3 className="resendOtp text-center">
                {props.t("didnt-receive-otp")}
                <Button
                  className="d-block p-button-text mx-auto my-2"
                  disabled={!canResend}
                  style={{ color: businessColor }}
                  label={props.t("click-here")}
                  onClick={resendOTP}
                />
                {props.t("to-resend-the-pin")}.
              </h3>
              <div className="d-flex justify-content-center verifyButtonDiv">
                <Button
                  disabled={otp.length !== 4}
                  className="otpVerifybutton"
                  loading={loader}
                  type="button"
                  iconPos="right"
                  onClick={verifyOTP}
                  label={props.t("verify")}
                  style={{ background: businessColor, border: businessColor }}
                />
              </div>
            </div>
          </div>
        </div>
      </OtpPageWrapper>
    </Dialog>
  );
};

export default withTranslation()(OtpPage);
